import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        locales: {
            "et-NL": "Estonia",
            "ru-NL": "Nederlands",
            "en-NL": "English",
            "fr-NL": "Français",
            "es-NL": "Espagnol",
            "de-NL": "Deutsch",
            "it-NL": "Italiano"
        },
        selectedLocale: "et-NL",
        i18n_values: {
            "en-NL": {
                notifications: {
                    val_report_submitted: "Thanks, this will make the valuation engine better!"
                },
                doesnt_seem_right: "Doesn\'t seem right?",
                comments: "Comments",
                val_report_help: "Unique property features? Other notes.",
                suggested_price: "What the price range should be?",
                suggested_price_min: "Correct min price",
                suggested_price_max: "Correct max price",
                deals_empty_title: "All pre-bookings, bookings and contracts are deals",
                deals_empty_desc: "You can create a deal manually under the property Manage view or they will be created automatically, when tenant is interested in Your listing.",
                filtered_props_appear: "Filtered properties appear here",
                chat_unavailable: "Chat is currently unavailable",
                valuation_hero_text: "We offer instant online valuations, just enter your address below for an indication of what your property is worth. You can get both sale and lettings valuation to see what yield you can achieve for your rental property.",
                show_all_images: "All pictures",
                show_all_videos: "Videos",
                min_stay_period_is: "Minimum stay period for this property is",
                days: "days",
                select_date_or_range: "Select single date or range",
                choose_stay_period: "Choose your stay period",
                edit_stay_period: "Edit stay period",
                sale: "Sale",
                rent: "Rent",
                say_hello: "Say Hello to",
                your_new_home: "Your new home!",
                find_home: "Find home",
                look: "View",
                valuation_engine: "Valuator",
                login: "Log in",
                signup: "Sign up",
                have_account: "Already have an account?",
                login_here: "Log in here",
                signup_here: "Sign up here",
                need_account: "Need Moowle account?",
                log_in_cta: "Faster and better renting. Secured.",
                learn_more:"Learn more",
                save:"Save",
                go_to_booking: "Go to booking",
                next: "Next",
                confirm: "Confirm",
                back: "Back",
                tenant_is_company:"Tenant is represented by a company",
                representative: "representative",
                guests_desc:"People who will live on the property",
                review_details: "Review Details",
                application: "Application",
                payment: "Payment",
                bank_account_info: "Your banking details",
                bank_account_info_desc: "Enter account details you wish to conduct transactions with",
                specify_id_first: "Specify You identity first",
                results_on_email: "Your valuation. You’re in control.",
                no_obligation:"There is no obligation to use Moowle once your rental is valued.",
                valuation_email_help_uus:"We’ll send your free rent estimate instantaneously and occasionally information related to Uusmaa. We do not spam! You can always adjust your preferences after receiving the first email.",
                valuation_email_help:"We’ll send your free rent estimate instantaneously and occasionally information related to Moowle. We do not spam! You can always adjust your preferences after receiving the first email.",
                similar_properties: "Similar properties",
                get_prediction: "Get valuation",
                nr_of_floors: "Nr of floors",
                floor_number: "Floor number",
                area: "Area",
                nr_of_rooms: "Nr of rooms",
                property_address_tallinn: "Property address in Tallinn",
                free_valuation: "Free Instant Rental Estimate",
                reviewAccomodationAgreement: "Review Agreement",
                landlordHasSigned: "Landlord has signed",
                tenantHasSigned: "Tenant has signed",
                landlordHasToSign: "Landlord has to sign",
                tenantHasToSign: "Tenant has to sign",
                tenantProfile: "tenant profile",
                ui: {
                    account: {
                        general: "GENERAL",
                        access: "USER ACCESS",
                        identity: "IDENTITY",
                        company: "COMPANY",
                        payments: "PAYMENTS",
                        accountName: "Account (company) name"
                    },
                    book: "Book now",
                    start: "Start Now For Free",
                    get_started: "List with Moowle",
                    learn_how: "Learn how Moowle works",
                    add_property: "Add property"
                },
                cancel: "Cancel",
                continue: "Continue",
                tc: {
                    confirmIdentityTitle: "Confirm Your Information",
                    confirmIdentityContent: "By continuing, You agree that the information entered here is correct and You have full rights to use this information",
                    confirmCompanyTitle: "Confirm Company Information",
                    confirmCompanyContent: "By continuing, You agree that the information entered here is correct and You have full rights to use this information"
                },
                contract: "Contract",
                terms: "Terms",
                current: "Current",
                your_role: "Your Role",
                chat: "Messenger",
                private_notes:"Private notes",
                tenant: "Tenant",
                landlord: {
                    hero_headline: "Smart new way to let and manage your property",
                    hero_subheadline: "Moowle is the most loved way to market rentals, choose tenants, agree lets and stay organised.",
                    hero_subheadline_2: "With proper tools, we’ll save you and your tenant time to focus on things that matter most to you in your life.",
                    user_for_free: "Basic tools are always free",
                    moow_what_more: "Tenant validation & chat, booking & contract management, calendar, pricing engine and notifications, all in one place.",
                    how_moowle_works: "How Moowle Works?",
                    free_rent_validation: "Check our pricing engine",
                    what_one_title: "Reach and convert tenants",
                    what_one_body: "Prepare your listings, control availabilities, prices, and tenants. \n Moowle will channel your listings and convert tenants back to a direct built-in chat & negotiation tool.",
                    what_one_body_2: "Tenant will then book and after you accept, calendar will be updated, payment timelines and contracts will be created. After built-in digital signing, tenant is ready to move in.",
                    what_one_body_3: "All this will happen in a single flow while you can enjoy analytics on listing performance and deal with validated inquiries only.",
                    what_two_title: "Manage your properties",
                    what_two_body: "Forget excel and tracking down on data entry errors. Moowle provides a single dashboard for owners, managers, accountants and tenants alike.",
                    what_two_body_2: "Get notified and review vacancies, track rent and utility payments, managed calendar and access digital contracts on the go.",
                    what_three_title: "Enjoy Peace of Mind",
                    what_three_body: "Focus on providing the best experience for your tenants not on tracking down errors, rent and causes for empty apartments.",
                    what_three_body_2: "Add  properties and let Moowle automatic conversion flows take care the flow from an external channel to signed contract.",
                    what_three_body_3: "We will notify you of any inquiries, bookings or other events that need your attention.",
                    req_demo: "Request a demo",
                    sign_up_for_free: "Sign up for free",
                    add_your_property: "Add Your Property",
                    add_your_property_sub: "And enjoy the most loved way to let and manage your property in Europe",
                    add_property: "Add My First Property",
                    landlord: "Landlord"
                },
                user_access: "User access",
                org_details: "Contact details",
                info_publish_criterias: "In order to publish and have tenants to book directly from the channel, add your identity under your Account view.",
                info_about_account: "All assets (e.g Properties) are managed by the account. System notifications will also arrive on account wide email (i.e your organization email).",
                info_user_access: "Invite others to join and access your organization account",
                info_account_org: "Account can be considered as one organization no matter how many people are in this organization.",
                accept_terms: "Accept Terms and Conditions",
                or_continue_w_tc: "Accomodation Agreement",
                choose_template: "Lease agreement",
                select_contract_type: "Select contract type",
                info_utility_costs: "These are additional utility costs that will are not included in the rent. If rent includes the utilty costs, specify the Utility Cost Cap (UCC). UCC is a max utilty cost limit, which when exceeded, will prompt an additional bill to the rent.",
                info_fees: "Additional fees",
                info_ucc: "UCC is the maximum utilty cost that is included in the rent price. If UCC is exceeded,an additional invoice to the rent can be created. Additional invoice amount will be the excess from the specified UCC limit.",
                payment_method: "Payment Method",
                to_complete_booking: "To complete Your booking, please select your payment method.",
                you_will_be_charged: "You will be charged",
                for_booking_fee: "for the Booking Fee.",
                reminder_booking_fee_refund: "Rembember, booking fee will be fully refunded if landlord doesn't accept the booking application.",
                total: "Total",
                total_rent: "Total rent",
                payment_timeline: "Payment timeline",
                breakdown: "Breakdown",
                due_now: "Due now",
                booking_fee: "Booking fee",
                before_moving_in: "Before moving in",
                during_your_stay: "During your stay",
                monthly_cost: "Monthly cost",
                monthly_cost_discounted: "Monthly cost (discounted)",
                house_rules: "House rules",
                im_tenant: "Tenant",
                im_landlord: "Landlord",
                talk_to_owner: "Talk to",
                propert_state_live: "live",
                propert_state_stored: "stored",
                propert_state_archived: "archived",
                apartment: "apartment",
                house: "house",
                garage: "garage",
                parking: "parking",
                parkinglot: "parkinglot",
                studio: "studio",
                penthouse: "penthouse",
                housepart: "housepart",
                summerHouse: "summerHouse",
                farmHouse: "farmHouse",
                terracedHouse: "terracedHouse",
                pairHouse: "pairHouse",
                detachedOneFamilyHouse: "detachedOneFamilyHouse",
                manor: "manor",
                villa: "villa",
                accommodation: "accommodation",
                bureau: "bureau",
                trade: "trade",
                warehouse: "warehouse",
                warehousemanufacturing: "warehousemanufacturing",
                other: "other",
                service: "service",
                foodservice: "foodservice",
                residential: "residential",
                arable: "arable",
                forest: "forest",
                noPurpose: "noPurpose",
                social: "social",
                manufacturing: "manufacturing",
                business: "business",
                transport: "transport",
                storage: "storage",
                store_room: "storage",
                socle: "socle",
                owner_preview_info: "This is a preview of how guests will see your listing.",
                description: "description",
                sanitary: "sanitary",
                amenities: "amenities",
                conditions: "conditions",
                price_starting_at: "Price starting at",
                day: "day",
                month: "month",
                additional_fees: "Additional fees",
                price_includes: "Price includes",
                property: "property",
                location: "location",
                tags: "tags",
                move_in: "Move in",
                move_out: "Move out",
                people: "people",       //"inimest"
                person: "person",        //"inimene"
                peoples: "peoples",      // "inimesed",
                guests: "guests",        // "külalised",
                your_listing: "Your listing",  // "Sinu object"
                talk_details_w_landlord: "No comission, no commitments",
                separate_wc_and_bath: "Separate WC & Bathroom",
                bedroom: "bedroom",
                bathroom: "bathroom",
                balcony: "balcony",
                building_year: "Building year",
                general_area: "General area",
                living_area: "Living area",
                fools_explicit: "Floors (Entry / Total)",
                property_type: "Property type",
                condition: "condition",
                building_material: "Building material",
                roof_material: "Roof material",
                energy_lable: "Energy label",
                heatings: "heatings",
                localGas: "Local gas",
                localSolid: "Local solid",
                stove: "stove",
                fireplace: "fireplace",
                electric: "electric",
                electricFloor: "Electric floor",
                waterFloor: "Water floor",
                central: "central",
                centralGas: "Central get",
                conditioner: "conditioner",
                ionHeating: "Ion heating",
                groundHeating: "Ground heating",
                oilHeating: "Oil heating",
                combined: "combination",
                airSourceHeatPump: "Air heat pump",
                sign_up: "Sign up",
                log_in: "Log in",
                market: "market",
                verify_account: "Verify account",
                profile: "profile",
                account: "account",
                calendar: "calendar",
                stays: "stays",
                deals: "deals",
                properties: "properties",
                log_out: "Log out",
                whats_new: "What's new",
                whats_moowle: "What is Moowle?",
                moowle_for_landlords_1: "For landlords, Moowle allows You to manage your properties, its ads, revenues, contracts and tenants all in one place",
                moowle_for_tenants_1: "For tenants, Moowle enables direct contact with the landlord, your stays and its contracts, payments all in one place.",
                contact_sales: "Contact sales",
                support: "support",
                events: "Parties & events allowed",
                familyFND: "Suitable for kids",
                pets: "Pets allowed",
                smoking: "Smoking allowed",
                disabFND: "Disability Friendly",
                sublease: "sublease",
                lng_with_who_case: "",
                moow_title_input_placeholder: "Moowle uses this as the main title",
                external_title_input_placeholder: "Other portals will use this as the title",
                listing_unavailable_error: "This property is no longer available!",
                see_others: "See others",
                edit: "Edit",
                add: "Add",
                unavailable: "unavailable",
                info_monthly_base_price: "Basepirce will we used to calculate discounted prices. Visitors will see the lowest calculated price by default.",
                guide: {
                    add_account_identity: "Add your identification code and name",
                    add_account_payment: "Add bank account details",
                    preview_talk_to_owner_expl: "Rent a place in just 3 steps" 
                },
                deal: {
                    pending_booking_payment: "Pending booking fee",
                    landlord_booking_fee_requirement: "Landlord will see this booking after the payment",
                    payment_failed: "Payment failed",
                    payment_failed_verbose: "Your booking fee payment has failed",
                    payment_cancelled: "Payment cancelled",
                    payment_cancelled_verbose: "The payment process was cancelled, try again",
                    payment_refunded: "Process halted, your fee is refunded",
                    payment_refunded_verbose: "Contact Moowle support",
                    booking_fee_refunded: "Your booking fee has been refunded",
                    pending_confirmation: "Pending confirmation",
                    done: "Your booking has been done! You will receive a response soon from the owner",
                    propspect_is_waiting: "Prospect is waiting for booking confirmation. Accept or decline this booking application",
                    confirmed: "Booking confirmed",
                    confirmed_verbose: "Landlord has confirmed the booking.",
                    you_confirmed: "You confirmed this booking. Now sign the contract.",
                    declined: "Booking declined",
                    declined_verbose: "We are sorry but the landlord has declined this booking. Your booking fee will be refunded.",
                    you_declined: "You declined this booking.",
                    declined_system: "Booking declined",
                    declined_system_verbose: "We are sorry but the landlord didn't reply. Your booking fee will be refunded.",
                    declined_system_verbose_owner: "24 hours has passed without action. Booking declined automatically.",
                    cancelled: "Booking cancelled",
                    cancelled_verbose: "You cancelled this booking",
                    tenant_cancelled: "Tenant has cancelled the booking",
                    pending_signatures: "Pending Contract Signatures",
                    pending_signatures_landlord: "Pending for landlord signature",
                    tenant_has_signed: "Tenant has signed the contract, waiting on you.",
                    landlord_has_signed: "Landlord has signed the contract, waiting on you.",
                    pending_signatures_tenant: "Pending for tenant signature",
                    contract_signed: "Contract Signed",
                    contract_signed_verbose: "Contract signed. Get ready to move in.",
                    contract_signed_verbose_2: "Contract signed. Tenant is moving in.",
                    contract_cancelled: "Contract cancelled",
                    contract_cancelled_verbose: "Agreement  has been cancelled",
                    contract_ended: "Contract has ended",
                    unknown_status: "Unknown status",
                    should_not_happen: "This should not happen, contact support",
                    deal_snapshot_desc: "Navigate deal changes by selecting its snapshots below",
                    booking_application_fee:"Booking application fee",
                    finalize_booking_fee: "To complete your booking, please select your bank.",
                    charge_of_booking_fee_of:"You will be charged for the Booking Fee of"
                },
                moow_title_placeholder: "This title is only used inside Moowle",
                deposit: "deposit",
                info:{
                    estimated_monthly_price: "estimated monthly rent is",
                    estimated_asking_price: "estimated value is",
                    estimation_disclaimer: "The forecasted monthly prices are based on listings with a similar location, size, and guest capacity. The actually rent may vary depending on the special features of the property, utilities or other additional costs, season, demand, and other factors.",
                    about_moow: "Smart & Free Way to Manage Your Rentals",
                    about_moow_2: "Moowle is the most loved way to market your rentals, choose tenants, agree lets and stay organized.",
                    about_moow_3: "With proper tools, we’ll save you and your tenant time to focus on things that matter most to you in your life.",
                    about_moow_cta: "Start managing your listings with Moowle and enjoy other automation tools like price prediction",
                    specifyPeriod: "Click to specify stay period",
                    booking: "Booking the place here, will assure the apartment will be saved to you. After booking through Moowle, you can proceed easily by signing a contract right here on the platform.",
                    choose_contract_template: "Automatically generated digitally signable contract document. Signing can be done here by both parties.",
                    choose_contract_tc: "Accept terms and no additional contract document is created. Tenant can accept this after you accept the booking.",
                    tc_not_allowed:"Booking period is more than 3 months, T&C is not allowed",
                    manage_properties: "Manage your Properties and distribute them as listings from here.",
                    no_properties:"No Properties",
                    add_first_prop: "Add your first property",
                    property_status:"Your Property Status",
                    property_statuses: "These 3 statuses reveal if the property is being listed on the market (live), not live (stored) or have been archived (archived).",
                    add_your_identity:"You info will be used for bookings and the contracts that follow. \n If you represent a company, please fill the info in the Company tab also.",
                    add_company_identity: "Add company details",
                    my_identity:"My identity",
                    my_company:"My company",
                    add_document: "Add passport or ID card copy",
                    will_be_used_in_future: "You can use these company details in future contracts (we'll let you know, you can edit this just before also)"
                },
                skip_contract_selection: "SKIP",
                pid: "Personal Identification Code",
                ssn: "Social Security or Tax Number",
                or_user_name: "No ID code?",
                or_user_id: "User ID code",
                given_name: "Given name",
                surname: "Surname",
                dob: "Date of birth",
                residential_address: "Residential Address",
                phone: "Phone",
                nationality: "Nationality",
                email: "Email",
                emailNotif: "Email (receive notifications here)",
                accountId: "Account ID",
                whoAreGuests: "A guest is a person who will actually stay in the apartment. It can, but doesn't have to be the person who will sign the contract. Guest details will also go to the contract."
            },
            "et-NL": {
                notifications: {
                    val_report_submitted: "Täname tagasiside eest, see teeb hinnamootorit paremaks!",
                },
                doesnt_seem_right: "Ei tundu õige?",
                comments: "Kommentaarid",
                val_report_help: "Unikaalsed objekti omadused? Muud märkused.",
                suggested_price: "Milline oleks õigem hinnavahemik?",
                suggested_price_min: "Õigem hinna alampiir",
                suggested_price_max: "Õigem hinna ülempiir",
                deals_empty_title: "Kõik eelbroneeringud, broneeringud ja lepingud on tehingud",
                deals_empty_desc: "Võite luua tehinug käsitsi objekti halduse vaates. Samuti luuakse uus tehing automaatselt, kui üürnik broneerib objekti.",
                filtered_props_appear: "Filtreeritud objektid on siin",
                chat_unavailable: "Chat pole hetkel saadaval",
                valuation_hero_text: "Pakume kohest veebihindamist. Sisestage oma aadress allpool, et näha, mis teie vara väärt on. Saadaval on nii müügi kui üürihindamine, et näha, millist tootlust võite oma üüripinnast oodata.",
                show_all_images: "Kõik pildid",
                show_all_videos: "Videod",
                min_stay_period_is: "Miinimum üüriperiood selles korteris on",
                days: "päeva",
                select_date_or_range: "Vali üks kuupäev või periood",
                choose_stay_period: "Palun vali üüriperiood",
                edit_stay_period: "Muuda üüriperiood",
                sale: "Müük",
                rent: "Üür",
                say_hello: "Ütle oma uuele",
                your_new_home: "kodule tere!",
                find_home: "Leia kodu",
                look: "Vaata",
                valuation_engine: "Hinnamootor",
                login: "Sisene",
                signup: "Loo kasutaja",
                have_account: "Konto olemas?",
                login_here: "Sisene siin",
                signup_here: "Loo konto siin",
                need_account: "Vaja uut kontot?",
                log_in_cta: "Kiirem ja lihtsam üürimine. Turvaliselt.",
                learn_more:"Vaata lisaks",
                save:"salvesta",
                go_to_booking: "Vaata broneeringut",
                next: "Edasi",
                confirm: "Kinnitan",
                back: "Tagasi",
                tenant_is_company:"Üürniku esindab ettevõte",
                representative: "esindab",
                guests_desc:"Isikud, kes siin elama hakkavad",
                review_details: "Detailid",
                application: "Avaldus",
                payment: "Makse",
                bank_account_info: "Panga detailid",
                bank_account_info_desc: "Lisa konto detailid, millega soovid tehindutes osaleda",
                specify_id_first: "Täpsusta oma identiteet enne kui lisad ettevõtte",
                results_on_email: "Sina omad kontrolli",
                no_obligation:"Sul puudub kohustus Moowle kasutamiseks, kui hinnangut vaatad.",
                valuation_email_help_uus:"Saadame teie tasuta üürihinnangu koheselt ja aeg-ajalt Uusmaaga seotud teavet. Me ei rämpsposti! Pärast esimese e-kirja saamist saate alati oma eelistusi kohandada.",
                valuation_email_help:"Saadame teie tasuta üürihinnangu koheselt ja aeg-ajalt Moowlega seotud teavet. Me ei rämpsposti! Pärast esimese e-kirja saamist saate alati oma eelistusi kohandada.",
                similar_properties: "Sarnased objektid",
                get_prediction: "Näita hinda",
                nr_of_floors: "Korruste arv",
                floor_number: "Korrus",
                area: "Pindala",
                nr_of_rooms: "Tubade arv",
                property_address_tallinn: "Tallinna korteri aadress",
                free_valuation: "Tasuta kohene hindamine",
                reviewAccomodationAgreement: "Tutvu lepinguga",
                landlordHasSigned: "Üürileandja on allkirjastanud",
                tenantHasSigned: "Üürnik on allkirjastanud",
                landlordHasToSign: "Üürileandja peab allkirjastama",
                tenantHasToSign: "Üürnik peab allkirjastama",
                tenantProfile: "üürniku profiil",
                ui: {
                    account: {
                        general: "ÜLDINE",
                        access: "LIGIPÄÄSUD",
                        identity: "IDENTITEET",
                        company: "ETTEVÕTE",
                        payments: "MAKSED",
                        accountName: "Konto (ettevõtte) nimi"
                    },
                    book: "Broneeri",
                    start: "Alusta Tasuta",
                    get_started: "Lisa korter tasuta",
                    learn_how: "Vaata kuidas Moowle töötab",
                    add_property: "Lisa objekt"
                },
                cancel: "Katkesta",
                continue: "Jätka",
                tc: {
                    confirmIdentityTitle: "Kinnitan andmed",
                    confirmIdentityContent: "Jätkates kinnitad, et informatsioon, mis sisestasid, käib sinu kohta või sul on esindusõigus.",
                    confirmCompanyTitle: "Kinnitan andmed",
                    confirmCompanyContent: "Jätkates kinnitad, et informatsioon, mis sisestasid, käib sinu kohta või sul on esindusõigus."
                },
                contract: "Leping",
                terms: "Tingimused",
                current: "Praegune",
                your_role: "Sinu roll",
                chat: "Messenger",
                private_notes:"Üürileandja märkmed",
                tenant: "Üürnik",
                landlord: {
                    hero_headline: "Uus ja tark viis üürikorterite haldamiseks.",
                    hero_subheadline: "Moowle on kõige armastatum viis üüride turustamiseks, üürnike valimiseks, üürilepingute kokkuleppimiseks ja korraldamiseks.",
                    hero_subheadline_2: " Sobivate tööriistade abil säästame teie ja teie üürniku aega, et teie saaksite keskenduda asjadele, mis on teie elus kõige olulisemad.",
                    moow_what_more: "Üürniku valideeimine ja chat, broneeringu ja lepingu haldus, kalender, hinnamootor ja teavitused kõik ühes kohas.",
                    user_for_free: "Platvorm on tasuta.",
                    how_moowle_works: "Kuidas Moowle töötab?",
                    free_rent_validation: "Tasuta automaatne hinnamootor",
                    what_one_title: "Reach and convert tenants",
                    what_one_body: "Prepare your listings, control availabilities, prices, and tenants. \n Moowle will channel your listings and convert tenants back to a direct built-in chat & negotiation tool.",
                    what_one_body_2: "When details are set, tenant will book and after your acceptance, calendars are updated, payment timeline and contract will be generated. After digital signature, tenant is ready to move in.",
                    what_one_body_3: "All in a single flow while you can enjoy analytics on listing performance and validated inquiries only.",
                    what_two_title: "Manage your properties",
                    what_two_body: "Forget excel and tracking down on data entry errors. Single dashboard for owners, managers, accountants and tenants.",
                    what_two_body_2: "Get notified and review vacancies, track rent and utility payments, managed calendar and access digital contracts on the go.",
                    what_three_title: "Enjoy Peace of Mind",
                    what_three_body: "Focus on providing the best experience for your tenants not on tracking down errors, rent and causes for empty apartments.",
                    what_three_body_2: "Add  properties and let Moowle's automatice conversion flows take care of the rest. \n From external channel to signed contract in a single flow.",
                    what_three_body_3: "We will notify you of any inquiries, bookings or other events that need review.",
                    req_demo: "Request a demo",
                    sign_up_for_free: "Sign up for free",
                    add_your_property: "Lisa Oma Kinnisvara",
                    add_your_property_sub: "Ja naudi kõige armastatumat üürikorteri haldamise viisi Euroopas",
                    add_property: "Lisa Minu Esimene Objekt",
                    landlord: "Üürileandja"
                },
                user_access: "Kasutajate ligipääsud",
                org_details: "Kontakt info",
                info_account_org: "Konto esindab sinu organisatsiooni, ükskõik kui palju inimesi seal on",
                info_user_access: "Kutsu teisi ühinema sinu organisatsiooni kontoga.",
                info_publish_criterias: "Avaldamiseks ja selleks, et üürnikud saaksid otse kanali seest broneerida, lisage Konto vaates oma identiteet.",
                info_about_account: "Kõik kinnisvaratehingud ja kalender kuuluvad konto alla. Moowle saadab teavitusi e-posti aadressile, mis on Moowle platvormist eraldiseisev (nt. teie organisatsiooni e-posti aadress).",
                accept_terms: "Nõustun tingimustega",
                choose_template: "Üürileping",
                or_continue_w_tc: "Majutusleping",
                select_contract_type: "Vali lepingu tüüp",
                info_utility_costs: "Üürile lisanduvad kõrvalkulud. Kui kõrvalkulud kuuluvad üüri sisse, täpsustad Utility Cost Cap (UCC). See on piirmäärk, mis on kõrvalkulude katteks üüri sisse arvestatud, mille ületamisel saab Üürnik lisa arve.",
                info_fees: "Lisakulud",
                info_ucc: "See on piirmäär (UUC), mis on kõrvalkulude katteks üüri sisse arvestatud. Selle ületamisel lisandub üürnikule arve, mille suurus on UCC piirmäära ületanud summa.",
                payment_method: "Makseviis",
                to_complete_booking: "Broneeringu lõpule viimiseks valige palun makseviis.",
                you_will_be_charged: "Hetkel peate tasuma",
                for_booking_fee: "broneeringu tasu.",
                reminder_booking_fee_refund: "Kui omanik ei peaks seda broneeringut aksepteerima, tagastatakse broneeringu tasu automaatselt täies ulatuses 24h pärast.",
                total: "Kokku",
                total_rent: "Kokku üür",
                payment_timeline: "Maksegraafik",
                breakdown: "Täpsemalt",
                due_now: "Kohe",
                booking_fee: "Broneeringu tasu",
                before_moving_in: "Enne sisse kolimist",
                during_your_stay: "Perioodi vältel",
                monthly_cost: "Kuu kulu",
                monthly_cost_discounted: "Kuu kulu (allahinnatud)",
                house_rules: "kodukord",
                im_tenant: "Üürnik",
                im_landlord: "Üürileandja",
                talk_to_owner: "Vestle", 
                propert_state_live: "avalik",
                propert_state_stored: "salvestatud",
                propert_state_archived: "arhiveeritud",
                apartment: "korter",
                house: "maja",
                garage: "garaaž",
                parking: "parkimine",
                studio: "stuudio",
                penthouse: "katusekorter",
                housepart: "maja osa",
                summerHouse: "suvila",
                farmHouse: "farm",
                terracedHouse: "ridaelamu",
                pairHouse: "paarismaja",
                detachedOneFamilyHouse: "üksikelamu",
                manor: "mõis",
                villa: "villa",
                accommodation: "majutus",
                bureau: "büroo",
                trade: "trade",
                warehouse: "ladu",
                warehousemanufacturing: "tootmisladu",
                other: "muu",
                service: "teenindus",
                foodservice: "toitlustus",
                residential: "elukondlik",
                arable: "maatulundusmaa",
                forest: "mets",
                noPurpose: "teadmata",
                social: "sotsiaal",
                manufacturing: "tootmine",
                business: "äri",
                transport: "transport",
                storage: "ladu",
                store_room: "panipaik",
                socle: "sokkel",
                owner_preview_info: "See on eelvaade, nii näevad külalised sinu kuulutust.",
                description: "kirjeldus",
                options: "valikud",
                sanitary: "sanitary",
                amenities: "mugavused",
                conditions: "tingimused",
                price_starting_at: "Hind alates",
                day: "päev",
                month: "kuu",
                additional_fees: "lisakulud",
                price_includes: "Hind sisaldab",
                property: "objekti info",
                location: "asukoht",
                tags: "sildid",
                move_in: "Sisse",
                move_out: "Välja",
                people: "inimest",
                person: "inimene",
                peoples: "inimesed",
                guests: "Külalised",
                your_listing: "Sinu kuulutus",
                talk_details_w_landlord: "Vahendustasuta ja kohustusi ei kaasne!",
                separate_wc_and_bath: "Eraldi WC ja vannituba",
                bedroom: "magamistuba",
                bathroom: "vannituba",
                balcony: "rõdu",
                building_year: "ehitusaasta",
                general_area: "üldpind",
                living_area: "elutuba",
                fools_explicit: "korrus (sissepääs / kokku)",
                property_type: "objekti tüüp",
                condition: "seisukord",
                building_material: "hoone materjal",
                roof_material: "katuse materjal",
                energy_label: "energiamärgis",
                heatings: "küte",
                localGas: "Kohalik gaas",
                localSolid: "Kohalik tahke",
                stove: "ahi",
                fireplace: "kamin",
                electric: "elekter",
                electricFloor: "põrandaküte (elekter)",
                waterFloor: "põrandaküte (vesi)",
                central: "keskküte",
                centralGas: "Kesk gaas",
                conditioner: "konditsioneer",
                ionHeating: "Ioonküte",
                groundHeating: "maaküte",
                oilHeating: "õliküte",
                combined: "sega",
                airSourceHeatPump: "õhksoojuspump",
                sign_up: "registreeru",
                log_in: "sisene",
                market: "turuplats",
                profile: "profiil",
                account: "konto",
                calendar: "kalender",
                stays: "ööbimised",
                deals: "tehingud",
                properties: "objektid",
                log_out: "välju",
                whats_new: "Mis uudist",
                whats_moowle: "Mis on Moowle?",
                moowle_for_landlords_1: "Üürileandjale võimaldab Moowle hallata ühest kohast üürikinnisvara andmeid, kuulutusi, üürisoove, üürisuhteid- ja lepinguid.",
                moowle_for_tenants_1: "Üürnikule pakub Moowle otsekontakti üürileandjaga ning mugavat ülevaadet oma üürisuhetest ja lepingulistest kohustustest.",
                contact_sales: "Võta ühendust müügiesindajaga",
                support: "kasutajatugi",
                events: "Peod ja üritused lubatud",
                familyFND: "Sobilik lastele",
                pets: "Koduloomad lubatud",
                smoking: "Suitsetamine lubatud",
                disabFND: "Erivajaduste sõbralik",
                sublease: "Edasirentimine",
                lng_with_who_case: "iga",
                moow_title_input_placeholder: "Moowle kasutab seda pealkirjana",
                external_title_input_placeholder: "Teised portaalid kasutavad seda pealkirjana",
                listing_unavailable_error: "See objekt pole enam saadaval!",
                see_others: "Vaata teisi",
                edit: "muuda",
                add: "lisa",
                unavailable: "Mitte saadaval",
                booking_fee_info_content: "Broneeringutasu piirmäära ja protsendi määrab omanik. Kui omanik pole seda määranud, siis vaikimisi piirmäär on 190eur või 10% kogu tehingu suuruses. Peale broneerimistasu maksmist näeb omanik teie broneeringut ning see kinnisvara broneeritakse tema kalendris teile! Kui omanik peaks keelduma broneeringust, on automaatne tagasimakse garanteeritud.",
                info_monthly_base_price: "Baashinnast arvutatakse soodustused. Kasutajatele kuvatakse vaikimis kõige soodsamat välja arvutatud hinda.",
                guide: {
                    add_account_identity: "Lisa oma isikukood ja nimi",
                    add_account_payment: "Lisa panga konto andmed",
                    preview_talk_to_owner_expl: "Üüri korter 3 sammuga" 
                },
                deal: {
                    pending_booking_payment: "Broneerimistasu ootel",
                    landlord_booking_fee_requirement: "Omanik näeb seda broneeringut peale makset.",
                    payment_failed: "Makse ebaõnnestus",
                    payment_failed_verbose: "Broneeringu tasu makse ebaõnnestus.",
                    payment_cancelled: "Makse on tühistatud",
                    payment_cancelled_verbose: "Makse protsess jäi katki, palun proovi uuesti",
                    payment_refunded: "Process halted, your fee is refunded",
                    payment_refunded_verbose: "Contact Moowle support",
                    booking_fee_refunded: "Teie broneerimistasu on tagastatud",
                    pending_confirmation: "Ootab omaniku kinnitust",
                    done: "Broneering tehtud! Omaniku vastus tuleb peatselt",
                    propspect_is_waiting: "Kinnitage või loobuge broneeringust, üürnik on ootel.",
                    confirmed: "Broneering kinnitatud",
                    confirmed_verbose: "Omanik on kinnitanud broneeringu.",
                    you_confirmed: "Te kinnitasite selle broneeringu. Nüüd allkirjastage leping.",
                    declined: "Broneering lükati tagasi",
                    declined_verbose: "Vabandame, omanik ei võtnud broneeringut vastu. Teie broneerimistasu tagastatakse!",
                    you_declined: "Te ei võtnud seda broneeringut vastu.",
                    declined_system: "Broneering lükati tagasi",
                    declined_system_verbose: "Vabandame, omanik ei võtnud broneeringut õigeaegselt vastu. Teie broneerimistasu tagastatakse!",
                    declined_system_verbose_owner: "24 tundi möödus ilma vastuseta, broneering tühistati automaatselt",
                    cancelled: "Broneering tühistatud",
                    cancelled_verbose: "Te tühistasite selle broneeringu",
                    tenant_cancelled: "Üürnik tühistas broneeringu",
                    pending_signatures: "Ootab lepingu allkirju",
                    pending_signatures_landlord: "Ootab omaniku allkirja",
                    tenant_has_signed: "Üürnik on allkirjastanud, palun lisage endi oma.",
                    landlord_has_signed: "Omanik on allkirjastanud, palun lisage endi oma.",
                    pending_signatures_tenant: "Ootab üürniku allkirja",
                    contract_signed: "Leping sõlmitud",
                    contract_signed_verbose: "Valmistu sisse kolimiseks.",
                    contract_signed_verbose_2: "Üürnik kolib sisse.",
                    contract_cancelled: "Leping tühistatud",
                    contract_cancelled_verbose: "Teatud põhjusel on leping tühistatud",
                    contract_ended: "Leping on lõppenud",
                    unknown_status: "Teadmata seis",
                    should_not_happen: "Seda ei tohiks juhtuda, palun võtke ühendust kasutajatoega.",
                    deal_snapshot_desc: "Muutused lepingus on kajastatud hetktõmmistena",
                    booking_application_fee:"Broneeringu tasu",
                    finalize_booking_fee: "Broneeringu sooritamiseks valige sobiv pank.",
                    charge_of_booking_fee_of:"Broneerimistasu suurus on",
                },
                moow_title_placeholder: "See pealkiri on kasutusel ainult Moowle keskkonnas",
                deposit: "deposiit",
                info:{
                    estimated_monthly_price: "hinnanguline kuu üür on",
                    estimated_asking_price: "hinnanguline väärtus on",
                    estimation_disclaimer: "Hinnang baseerub sarnaste objektide analüüsist. Võrdlusel võetakse arvesse samu tegureid, mida võtavad arvesse elukutselised maaklerid ja hindajad. Nendeks on asukoht, tubade arv, pindala, lisanväärtus, seisukord ja ehitise aasta arv. Sealhulgas arvestab Moowle hinnangu mootor kokku ligikaudu 20 erinevat tegurit.",
                    about_moow: "Tark ja tasuta võimalus manageerida oma üüri kinnisvara",
                    about_moow_2: "Moowle on armastatuim viis hallata oma üüri kortereid, valida üürnikke, sõlmida lepinguid ning olla organiseeritud.",
                    about_moow_3: "Tugevate tööriistadega säästad nii enda kui sinu üürniku aega. Nii saad keskenduda sellele, mis on sulle elus kõige tähtsam.",
                    about_moow_cta: "Halda oma kinnisvara Moowlega ning naudi ka teisi automatiseeritud tööriistu nagu kanali haldus, üürniku taust, chat, lepingute sõlmimine.",
                    specifyPeriod: "Kliki, et täpsustada periood",
                    booking: "Broneerides siin, hoitakse korter teile. Peale broneeringu kinnitamist, saate mugavalt Moowles ka kohe lepingu allkirjastada. Nii püsib kõik info ühes kohas ja korteri üürimine on lihtne kui 1-2-3", 
                    choose_contract_template: "Luuakse eraldi digiallkirjastatav lepingu dokument. Allkirjastada saavad mõlemad osapooled seda siinsamas.",
                    choose_contract_tc: "Majutuslepingu puhul pead vaid nõustuma tingimustega ja eraldi lepingu dokumenti ei looda. Peale aksepteerimist, küsitakse üürnikul sellega samuti nõustuda.",
                    tc_not_allowed:"Kuna periood on pikem kui 3 kuud siis see valik pole saadaval",
                    manage_properties: "Halda oma kinnisvara siin ja kontrolli nende näitamisi portaalides. Lisaks haldad Moowles ära ka oma lepingud, kalendri ja üürnikuga chati",
                    no_properties:"Kinnisvara puudub",
                    add_first_prop: "Lisa oma esimene kinnisvara",
                    property_status:"Kinnisvara staatused",
                    property_statuses: "Need 3 staatust näitavad, kas objekt on kuulutusena väljas ('Avalik'), mitte avalik ('Salvestatud'), või arhiveeritud ('Arhiveeritud').",
                    add_your_identity:"Sinu infot kasutatakse vaid broneerimise ja sellele järgneva lepingu tegemiseks. \n Kui soovid tegutseda ettevõttena, siis täida ka 'Ettevõtte' tab.",
                    add_company_identity: "Ettevõtte andmed",
                    my_identity:"Minu andmed",
                    my_company:"Minu ettevõte",
                    add_document: "Lisa passi või id kaardi koopia",
                    will_be_used_in_future: "Neid andmeid kasutatakse lepingu tegemisel (võimalus hiljem vahetult veel muuta)"
                },
                skip_contract_selection: "JÄTA VAHELE",
                pid: "Isikukood",
                ssn: "SSN või Maksuregistri kood",
                or_user_name: "pole ID koodi?",
                or_user_id: "kasuta isikukoodi",
                given_name: "Eesnimi",
                surname: "Perenimi",
                dob: "Sünnikuupäev",
                residential_address: "Kodu aadress",
                phone: "Telefon",
                nationality: "Rahvus",
                email: "E-post",
                emailNotif: "E-post (siia tulevad ka teavitused)",
                accountId: "Konto ID",
                whoAreGuests: "Külaline on isik(ud), kes tegelikult korteris elama hakkab. Külaline võib, aga ei pea olema isik, kellega ka leping sõlmitakse. Külaliste andmed lähevad samuti lepingule."

            },
            "ru-NL": {
                notifications: {
                    val_report_submitted: "Спасибо, это сделает систему оценки лучше!",
                },
                doesnt_seem_right: "Не кажется правильным?",
                comments: "Комментарии",
                val_report_help: "Уникальные особенности недвижимости? Прочие примечания",
                suggested_price: "Какой будет правильный ценовой диапазон?",
                suggested_price_min: "Правильная минимальная цена",
                suggested_price_max: "Правильная максимальная цена",
                deals_empty_title: "Все предварительные заказы, заказы и контракты являются сделками.",
                deals_empty_desc: "You can create a deal manually under the property Manage view or they will be created automatically, when tenant is interested in Your listing.Вы можете создать сделку вручную в свойстве Manage view, или они будут созданы автоматически, когда арендатор заинтересуется Вашим объявлением.",
                filtered_props_appear: "Отфильтрованные свойства отображаются здесь",
                chat_unavailable: "Чат в настоящее время недоступен",
                valuation_hero_text: "Мы предлагаем мгновенные онлайн-оценки. Просто введите свой адрес ниже, чтобы узнать, сколько стоит ваша недвижимость. Вы можете получить оценку как продажи, так и сдачи внаем, чтобы увидеть, какой доход вы можете получить от арендуемой собственности.",
                show_all_images: "Все картинки",
                show_all_videos: "Ролики",
                min_stay_period_is: "Минимальный период проживания в этом объекте размещения составляет",
                days: "дней",
                select_date_or_range: "Выберите одну дату или диапазон",
                choose_stay_period: "Выберите период пребывания",
                edit_stay_period: "Изменить период пребывания",
                sale: "Pаспродажа",
                rent: "Aрендная плата",
                say_hello: "Поздоровайся с твоим",
                your_new_home: "новым домом!",
                find_home: "найти дом",
                look: "смотреть",
                valuation_engine: "Оценка",
                login: "Авторизоваться",
                signup: "зарегистрироваться",
                have_account: "Уже есть аккаунт?",
                login_here: "Авторизуйтесь здесь",
                signup_here: "Подпишите здесь",
                need_account: "Нужна учетная запись Moowle?",
                log_in_cta: "Faster and better renting. Secured.",
                learn_more:"Узнать больше",
                save:"спасти",
                go_to_booking: "Перейти к бронированию",
                next: "следующий",
                confirm: "Подтвердить",
                back: "назад",
                tenant_is_company:"Арендатор в лице компании",
                representative: "представитель",
                guests_desc:"Люди, которые будут жить в собственности",
                review_details: "Подробности обзора",
                application: "3аявка",
                payment: "Оплата",
                bank_account_info: "Ваши банковские реквизиты",
                bank_account_info_desc: "Введите учетную запись, с которой вы хотите проводить транзакции",
                specify_id_first: "Сначала укажите свою личность",
                results_on_email: "Ваша оценка. Все под контролем.",
                no_obligation:"После того, как ваша аренда будет оценена, вы не обязаны использовать Moowle.",
                valuation_email_help_uus:"Мы будем мгновенно отправлять вам бесплатную смету арендной платы, а иногда и информацию, связанную с Uusmaa. Мы не спамим! Вы всегда можете изменить свои предпочтения после получения первого письма.",
                valuation_email_help:"Мы будем мгновенно отправлять вам бесплатную смету арендной платы, а иногда и информацию, связанную с Moowle. Мы не спамим! Вы всегда можете изменить свои предпочтения после получения первого письма.",
                similar_properties: "Похожие объекты",
                get_prediction: "Показать цену",
                nr_of_floors: "Количество этажей",
                floor_number: "Пол", 
                area: "Площадь",
                nr_of_rooms: "Кол-во комнат",
                property_address_tallinn: "Адрес недвижимости в Таллинне",
                free_valuation: "Бесплатная мгновенная оценка аренды",
                reviewAccomodationAgreement: "Соглашение о пересмотре",
                landlordHasSigned: "Арендодатель подписал",
                tenantHasSigned: "Арендатор подписал",
                landlordHasToSign: "Арендодатель должен подписать",
                tenantHasToSign: "Арендатор должен подписать",
                tenantProfile: "профиль арендатора",
                ui: {
                    account: {
                        general: "ОБЩЕЕ",
                        access: "ДОСТУП ПОЛЬЗОВАТЕЛЯ",
                        identity: "ИДЕНТИЧНОСТЬ",
                        company: "КОМПАНИЯ",
                        payments: "ПЛАТЕЖИ",
                        accountName: "Имя аккаунта (компании)"
                    },
                    book: "заказать сейчас",
                    start: "Начни сейчас бесплатно",
                    get_started: "Список с Moowle",
                    learn_how: "Узнайте, как работает Moowle",
                    add_property: "Добавить недвижимость"
                },
                cancel: "Отмена",
                continue: "Продолжать",
                tc: {
                    confirmIdentityTitle: "Подтвердите вашу информацию",
                    confirmIdentityContent: "Продолжая, вы соглашаетесь с тем, что введенная здесь информация верна, и что у вас есть все права на ее использование.",
                    confirmCompanyTitle: "Подтвердите информацию о компании",
                    confirmCompanyContent: "Продолжая, вы соглашаетесь с тем, что введенная здесь информация верна, и что у вас есть все права на ее использование."
                },
                contract: "договор",
                terms: "термины",
                current: "текущий",
                your_role: "Ваша роль",
                chat: "посыльный",
                private_notes:"личные заметки",
                tenant: "арендатор",
                landlord: {
                    hero_headline: "Smart new way to let and manage your property",
                    hero_subheadline: "Moowle is the most loved way to market rentals, choose tenants, agree lets and stay organised.",
                    hero_subheadline_2: "With proper tools, we’ll save you and your tenant time to focus on things that matter most to you in your life.",
                    user_for_free: "Basic tools are always free",
                    moow_what_more: "Tenant validation & chat, booking & contract management, calendar, pricing engine and notifications, all in one place.",
                    how_moowle_works: "How Moowle Works?",
                    free_rent_validation: "Automatic Free Rent Valuation",
                    what_one_title: "Reach and convert tenants",
                    what_one_body: "Prepare your listings, control availabilities, prices, and tenants. \n Moowle will channel your listings and convert tenants back to a direct built-in chat & negotiation tool.",
                    what_one_body_2: "When details are set, tenant will book and after your acceptance, calendars are updated, payment timeline and contract will be generated. After digital signature, tenant is ready to move in.",
                    what_one_body_3: "All in a single flow while you can enjoy analytics on listing performance and validated inquiries only.",
                    what_two_title: "Manage your properties",
                    what_two_body: "Forget excel and tracking down on data entry errors. Single dashboard for owners, managers, accountants and tenants.",
                    what_two_body_2: "Get notified and review vacancies, track rent and utility payments, managed calendar and access digital contracts on the go.",
                    what_three_title: "Enjoy Peace of Mind",
                    what_three_body: "Focus on providing the best experience for your tenants not on tracking down errors, rent and causes for empty apartments.",
                    what_three_body_2: "Add  properties and let Moowle's automatice conversion flows take care of the rest. \n From external channel to signed contract in a single flow.",
                    what_three_body_3: "We will notify you of any inquiries, bookings or other events that need review.",
                    req_demo: "Request a demo",
                    sign_up_for_free: "Sign up for free",
                    add_your_property: "Add Your Property",
                    add_your_property_sub: "And enjoy the most loved way to let and manage your property in Europe",
                    add_property: "Add My First Property",
                    landlord: "арендодатель"
                },
                user_access: "Доступ пользователя",
                org_details: "Контактная информация",
                info_publish_criterias: "Чтобы публиковать и бронировать арендаторов прямо с канала, добавьте свою личность в разделе «Учетная запись».",
                info_about_account: "All assets (e.g Properties) are managed by the account. System notifications will also arrive on account wide email (i.e your organization email).",
                info_user_access: "Invite others to join and access your organization account",
                info_account_org: "Account can be considered as an organization",
                accept_terms: "Принять условия",
                choose_template: "Договор аренды",
                or_continue_w_tc: "Договор проживания",
                select_contract_type: "Выберите тип контракта",
                info_utility_costs: "These are additional utility costs that will are not included in the rent. If rent includes the utilty costs, specify the Utility Cost Cap (UCC). UCC is a max utilty cost limit, which when exceeded, will prompt an additional bill to the rent.",
                info_fees: "Additional fees",
                info_ucc: "UCC is the maximum utilty cost that is included in the rent price. If UCC is exceeded,an additional invoice to the rent can be created. Additional invoice amount will be the excess from the specified UCC limit.",
                payment_method: "Способ оплаты",
                to_complete_booking: "To complete Your booking, please select your payment method.",
                you_will_be_charged: "You will be charged",
                for_booking_fee: "for the Booking Fee.",
                reminder_booking_fee_refund: "Rembember, booking fee will be fully refunded if landlord doesn't accept the booking application.",
                total: "Всего",
                total_rent: "Общая стоимость аренды",
                payment_timeline: "Сроки оплаты",
                breakdown: "Pазбивка",
                due_now: "Cейчас",
                booking_fee: "плата за бронирование",
                before_moving_in: "до переезда",
                during_your_stay: "во время вашего пребывания",
                monthly_cost: "ежемесячная стоимость",
                monthly_cost_discounted: "Ежемесячная стоимость (со скидкой)",
                house_rules: "Домашние правила",
                im_tenant: "Aрендатор",
                im_landlord: "правитель",
                talk_to_owner: "Oбщаться с",
                propert_state_live: "Живая",
                propert_state_stored: "Хранится",
                propert_state_archived: "архивации",
                apartment: "квартира",
                house: "дом",
                garage: "гараж",
                parking: "стоянка",
                parkinglot: "парковка",
                studio: "studio",
                penthouse: "penthouse",
                apartment: "apartment",
                housepart: "housepart",
                summerHouse: "summerHouse",
                farmHouse: "farmHouse",
                terracedHouse: "terracedHouse",
                pairHouse: "pairHouse",
                detachedOneFamilyHouse: "detachedOneFamilyHouse",
                manor: "manor",
                villa: "villa",
                accommodation: "accommodation",
                bureau: "bureau",
                trade: "trade",
                warehouse: "warehouse",
                warehousemanufacturing: "warehousemanufacturing",
                other: "other",
                service: "service",
                foodservice: "foodservice",
                residential: "residential",
                arable: "arable",
                forest: "forest",
                noPurpose: "noPurpose",
                social: "social",
                manufacturing: "manufacturing",
                business: "business",
                transport: "transport",
                storage: "storage",
                store_room: "storage",
                socle: "socle",
                owner_preview_info: "This is a preview of how guests will see your listing.",
                description: "description",
                sanitary: "sanitary",
                amenities: "amenities",
                conditions: "conditions",
                price_starting_at: "Price starting at",
                day: "day",
                month: "month",
                additional_fees: "Additional fees",
                price_includes: "Price includes",
                property: "Объект",
                location: "место расположения",
                tags: "tags",
                move_in: "Move in",
                move_out: "Move out",
                people: "people",
                person: "person",
                peoples: "peoples",
                guests: "Гости",
                your_listing: "Your listing",
                talk_details_w_landlord: "No comission, no commitments!",
                separate_wc_and_bath: "Separate WC & Bathroom",
                bedroom: "bedroom",
                bathroom: "bathroom",
                balcony: "balcony",
                building_year: "Building year",
                general_area: "General area",
                living_area: "Living area",
                fools_explicit: "Floors (Entry / Total)",
                property_type: "Property type",
                condition: "состояние",
                building_material: "Building material",
                roof_material: "Roof material",
                energy_lable: "Energy label",
                heatings: "heatings",
                localGas: "Local gas",
                localSolid: "Local solid",
                stove: "stove",
                fireplace: "fireplace",
                electric: "electric",
                electricFloor: "Electric floor",
                waterFloor: "Water floor",
                central: "central",
                centralGas: "Central get",
                conditioner: "conditioner",
                ionHeating: "Ion heating",
                groundHeating: "Ground heating",
                oilHeating: "Oil heating",
                combined: "combination",
                airSourceHeatPump: "Air heat pump",
                sign_up: "зарегистрироваться",
                log_in: "Авторизоваться",
                market: "рынок",
                profile: "профиль",
                account: "учетная запись",
                calendar: "календарь",
                stays: "остается",
                deals: "сделка",
                properties: "hедвижимость",
                log_out: "bыйти",
                whats_new: "What's new",
                whats_moowle: "What is Moowle?",
                moowle_for_landlords_1: "For landlords, Moowle allows You to manage your properties, its ads, revenues, contracts and tenants all in one place",
                moowle_for_tenants_1: "For tenants, Moowle enables direct contact with the landlord, your stays and its contracts, payments all in one place.",
                contact_sales: "Contact sales",
                support: "support",
                events: "Parties & events allowed",
                familyFND: "Suitable for kids",
                pets: "Pets allowed",
                smoking: "Smoking allowed",
                disabFND: "Disability Friendly",
                sublease: "sublease",
                lng_with_who_case: "",
                moow_title_input_placeholder: "Moowle uses this as the main title",
                external_title_input_placeholder: "Other portals will use this as the title",
                listing_unavailable_error: "This property is no longer available!",
                see_others: "See others",
                edit: "Edit",
                add: "Добавить",
                unavailable: "unavailable",
                booking_fee_info_content: "Booking free upper limit and precentage is set by the landlord. If landlord hasn't set them, then a default upper limit of 190eur or 10% will apply. After payment of the Booking Fee, landlord will see your booking request and the property is reserved to you. Should landlord not accept your booking, a full auto refund is guaranteed.",
                info_monthly_base_price: "Basepirce will we used to calculate discounted prices. Visitors will see the lowest calculated price by default.",
                guide: {
                    add_account_identity: "Добавьте свой идентификационный код и имя",
                    add_account_payment: "Добавьте реквизиты банковского счета",
                    preview_talk_to_owner_expl: "Сдам квартиру всего за 3 шага" 
                },
                deal: {
                    pending_booking_payment: "Pending booking fee",
                    landlord_booking_fee_requirement: "Landlord will see this booking after the payment",
                    payment_failed: "Payment failed",
                    payment_failed_verbose: "Your booking fee payment has failed",
                    payment_cancelled: "Payment cancelled",
                    payment_cancelled_verbose: "The payment process was cancelled, try again",
                    payment_refunded: "Process halted, your fee is refunded",
                    payment_refunded_verbose: "Contact Moowle support",
                    booking_fee_refunded: "Your booking fee has been refunded",
                    pending_confirmation: "Pending confirmation",
                    done: "Your booking has been done! You will receive a response soon from the owner",
                    propspect_is_waiting: "Prospect is waiting for booking confirmation. Accept or decline this booking application",
                    confirmed: "Booking confirmed",
                    confirmed_verbose: "Landlord has confirmed the booking.",
                    you_confirmed: "You confirmed this booking. Now sign the contract.",
                    declined: "Booking declined",
                    declined_verbose: "We are sorry but the landlord has declined this booking. Your booking fee will be refunded.",
                    you_declined: "You declined this booking.",
                    declined_system: "Booking declined",
                    declined_system_verbose: "We are sorry but the landlord didn't reply. Your booking fee will be refunded.",
                    declined_system_verbose_owner: "24 hours has passed without action. Booking declined automatically.",
                    cancelled: "Booking cancelled",
                    cancelled_verbose: "You cancelled this booking",
                    tenant_cancelled: "Tenant has cancelled the booking",
                    pending_signatures: "Pending Contract Signatures",
                    pending_signatures_landlord: "Pending for landlord signature",
                    tenant_has_signed: "Tenant has signed the contract, waiting on you.",
                    landlord_has_signed: "Landlord has signed the contract, waiting on you.",
                    pending_signatures_tenant: "Pending for tenant signature",
                    contract_signed: "Contract Signed",
                    contract_signed_verbose: "Contract signed. Get ready to move in.",
                    contract_signed_verbose_2: "Contract signed. Tenant is moving in.",
                    contract_cancelled: "Contract cancelled",
                    contract_cancelled_verbose: "Agreement  has been cancelled",
                    contract_ended: "Contract has ended",
                    unknown_status: "Unknown status",
                    should_not_happen: "This should not happen, contact support",
                    deal_snapshot_desc: "Navigate deal changes by selecting its snapshots below",
                    booking_application_fee:"Booking application fee",
                    finalize_booking_fee: "To complete your booking, please select your bank.",
                    charge_of_booking_fee_of:"You will be charged for the Booking Fee of"
                },
                moow_title_placeholder: "This title is only used inside Moowle",
                deposit: "deposit",
                info:{
                    estimated_monthly_price: "риентировочная ежемесячная арендная плата составляет",
                    estimated_asking_price: "oриентировочная стоимость",
                    estimation_disclaimer: "Прогнозируемые ежемесячные цены основаны на объявлениях с аналогичным местоположением, размером и количеством гостей. Фактическая арендная плата может варьироваться в зависимости от особенностей собственности, коммунальных услуг или других дополнительных затрат, сезона, спроса и других факторов.",
                    about_moow: "Smart & Free Way to Manage Your Rentals",
                    about_moow_2: "Moowle is the most loved way to market your rentals, choose tenants, agree lets and stay organized.",
                    about_moow_3: "With proper tools, we’ll save you and your tenant time to focus on things that matter most to you in your life.",
                    about_moow_cta: "Start managing your listings with Moowle and enjoy other automation tools like price prediction",
                    specifyPeriod: "Нажмите, чтобы указать период пребывания",
                    booking: "Забронировав место здесь, вы гарантируете, что квартира будет сохранена для вас. После бронирования через Moowle вы можете легко продолжить, подписав контракт прямо здесь, на платформе.",
                    choose_contract_template: "Automatically generated digitally signable contract document. Signing can be done here by both parties.",
                    choose_contract_tc: "Accept terms and no additional contract document is created. Tenant can accept this after you accept the booking.",
                    tc_not_allowed:"Booking period is more than 3 months, T&C is not allowed",
                    manage_properties: "Manage your Properties and distribute them as listings from here.",
                    no_properties:"No Properties",
                    add_first_prop: "Добавьте свою первую недвижимость",
                    property_status:"Your Property Status",
                    property_statuses: "These 3 statuses reveal if the property is being listed on the market (live), not live (stored) or have been archived (archived).",
                    add_your_identity:"You info will be used for bookings and the contracts that follow. \n If you represent a company, please fill the info in the Company tab also.",
                    add_company_identity: "Add company details",
                    my_identity:"My identity",
                    my_company:"My company",
                    add_document: "Add passport or ID card copy",
                    will_be_used_in_future: "You can use these company details in future contracts (we'll let you know, you can edit this just before also)"
                },
                skip_contract_selection: "ПРОПУСКАТЬ",
                pid: "Персональный идентификационный код",
                ssn: "Номер социального страхования или налог",
                or_user_name: "нет идентификационного кода?",
                or_user_id: "использовать идентификационный код",
                given_name: "Собственное имя",
                surname: "Фамилия",
                dob: "Дата рождения",
                residential_address: "Адрес проживания",
                phone: "Телефон",
                nationality: "Национальность",
                email: "е-мейл",
                emailNotif: "Электронная почта (получать уведомления здесь)",
                accountId: "ID аккаунта",
                whoAreGuests: "Гость - это человек, который фактически будет проживать в квартире. Может, но не обязательно должен подписывать контракт. Реквизиты гостя также войдут в договор."
            }
        }
    },
    getters: {
        selectedLocale: state => {
            return state.selectedLocale;
        },
        i18n_local: state => {
            return state.i18n_values[state.selectedLocale];
        }
    },
    mutations: {
        setLocale: (state, locale) => {
            state.selectedLocale = locale;
        }
    },
    actions: {
        setLocale({ state, commit }, { locale }) {
            state.selectedLocale != locale ? commit("setLocale", locale) : void 0;
            localStorage.setItem("selected_locale", locale);
        },
        defaultLocale({ state, commit }){
            var localLocale = localStorage.getItem("selected_locale")
            localLocale?state.selectedLocale = localLocale: void 0;
        }
    }
}



// WEBPACK FOOTER //
// ./src/vuex/internationalization/index.js